import {$body} from '../Constants';
import SwiperSlider from './SwiperSlider';

/**
 * Image With Box Slider
 */
const ImageWithBoxSlider = (() => {
	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		IMAGE_WITH_BOX_SLIDER: '.image-with-box-slider.swiper-container',
	};

	/**
	 * Image With Box Slider
	 *
	 * @class
	 * @augments SwiperSlider
	 */
	class ImageWithBoxSlider extends SwiperSlider {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			super.onReady();

			this.setOptions({
				slidesPerView: 1,
				grabCursor: true,
				effect: 'fade',
				autoplay: {
					delay: 5000,
					disableOnInteraction: false
				}
			});

			this._initialize();
		}
	}

	return ImageWithBoxSlider._getElements($body.find(Selector.IMAGE_WITH_BOX_SLIDER), ImageWithBoxSlider);
})();

export default ImageWithBoxSlider;
